export const GET_TAVERN='GET_TAVERN';

export const getTavern = ()=>{
  return {
    type:GET_TAVERN
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js